import React from 'react';
import style from './style.scss';
import {SubCategoryMenu} from 'components/category';
import {AdvancedSearch} from './advanced-search';
import {ListFilter} from './list-filter';
import {ListProductResult} from './list-product-result';
import {findCategoryInList} from 'base/lib/findCategoryInList';
import {NoContent} from 'components/no-content';
import {connect} from 'react-redux';
import {LoadingPage} from 'components/loading-page';
import {Categories, Products} from 'api';
import {withRouter} from 'react-router-dom';
import {ShowIf} from 'components/utils';

class ListProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      count: 0,
      skip: 0,
      limit: 12,
      isLoading: true,
      category: {},
      categoryId: this.props.params.catID
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    if (this.props.params.catID && this.props.categoryHash) {
      let matchedCategory = this.props.categoryHash[this.props.params.catID];

      this.setState({category: matchedCategory || {}});
      document.title = matchedCategory && matchedCategory.name ? matchedCategory.name : 'DaklakTrade';

      Categories.actions.countProduct.request({id: this.props.params.catID}).then((response) => {
        this.setState({count: response.data.count});
        this.getList();
      }).catch((error) => {
        this.props.history.push('/');
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.categoryHash) {
      let matchedCategory = nextProps.categoryHash[nextProps.params.catID];
      this.setState({category: matchedCategory || {}, categoryId: nextProps.params.catID});

      document.title = matchedCategory && matchedCategory.name ? matchedCategory.name : 'DaklakTrade';

      if (this.props.params.catID !== nextProps.params.catID) {
        Categories.actions.countProduct.request({id: nextProps.params.catID}).then((response) => {
          this.setState({count: response.data.count, data: []});
          this.getList();
        }).catch((error) => {
          this.props.history.push('/');
        });
      }
    }
  }

  getList() {
    if (this.state.categoryId) {
      this.setState({isLoading: true});
      //category Sản phẩm công nghiệp nông thôn tiêu biểu
      if (this.state.categoryId == "59f1f789cc2c260ce26843f0") {
        let params = {
          filter: {
            limit: this.state.limit,
            skip: this.state.skip,
            where: {
              isIndustryFeatured: true
            },
            order: 'createdAt DESC'
          }
        };

        Products.actions.list.request(params).then(response => {
          if (response && response.data) {
            let products = this.state.data;
            response.data.map((item, idx) => {
              products.push(item);
            });
            this.setState({data: products, isLoading: false});
          }
        }).catch(() => {
          this.setState({isLoading: false});
        });
      } else {
        let params = {
          id: this.state.categoryId,
          filter: {
            limit: this.state.limit,
            skip: this.state.skip,
            where: {
              status: 1
            },
            order: 'updatedAt DESC'
          }
        };
        Categories.actions.listProducts.request(params).then(response => {
          if (response && response.data) {
            let products = this.state.data;
            response.data.map((item, idx) => {
              products.push(item);
            });
            this.setState({data: products, isLoading: false});
          }
        }).catch(() => {
          this.setState({isLoading: false});
        });
      }
    }
  }

  loadMore() {
    this.setState({skip: this.state.skip + 12}, () => {
      this.getList();
    });
  }

  render() {
    return (
      <section className="center">
        <LoadingPage isShow={this.state.isLoading} />
        <div className="list-product-container">
          <div className="product-left-filter">
            <div className="wrap-item">
              <h4 className="list-title">Danh mục sản phẩm</h4>
              <SubCategoryMenu category={this.state.category}/>
            </div>
          </div>
          <div className="product-right-list">
            <div className="product-right-wrap">
              <ShowIf condition={this.state.data.length > 0}>
                <ListProductResult data={this.state.data} />
              </ShowIf>
              <ShowIf condition={this.state.data.length == 0 && !this.state.isLoading}>
                <div className="list-product-result">
                  <NoContent content='Không có Thiết bị nào' height={505}/>
                </div>
              </ShowIf>
              <ShowIf condition={!this.state.isLoading && this.state.data.length > 0 && (this.state.skip + this.state.limit) < this.state.count}>
                <button type="button" className="btn-viewmore-product" onClick={this.loadMore}>
                  <span className="btn-viewmore-text">Xem Thêm</span>
                </button>
              </ShowIf>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categoryHash: state.categoryHash,
    categories: state.categories
  };
};

export default withRouter(connect(mapStateToProps)(ListProduct));



// WEBPACK FOOTER //
// ./components/list-product/ListProduct.jsx